import { Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})

export class RtbPartnerService {
  public defaultRTBPartner: any;

  constructor(private userService: UserService) {
    this.defaultRTBPartner = {
      id: -1,
      name: '',
      endpoint: ''
    };

    if (this.userService.isAdmin()) {
      this.defaultRTBPartner.config_json = '';
    }
  }
}
